export default __webpack_public_path__ + "static/media/angpao-bg-mobile.f52878a0.jpg";